export default __webpack_public_path__ + "static/media/3.c9a76b37.png";